import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/"
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/orgs/$organizationId/projects/$projectId/home",
      params: {
        organizationId: params.organizationId,
        projectId: params.projectId,
      },
    });
  },
});
